export default __webpack_public_path__ + "Assets/FAMILY_BONUS/nordwest/Teilnahme-Bedingungen_zum_AOK-Familienbonus.pdf";